import * as i18n from 'CMS/core/i18n';
import { messageToParent } from 'CMS/Popup';
import CMSPopup from 'CMS/UI/Popup';
import ShipLink from '../Data/Entities/ShipLink';
import Vessels from '../UI/Vessels/Vessels';

export default class SelectVesselPopup {
    public callback: (data: ShipLink) => void;
    private popup: CMSPopup = null;
    private vessels: Vessels;

    constructor(callback: (data: ShipLink) => void) {
        this.callback = callback;
        this.popup = new CMSPopup();
        this.vessels = new Vessels();
    }

    public async open() {
        const $content = await this.getContent();

        this.popup.show({
            draggable: false,
            content: $content,
            title: this.getTitle(),
            width: 1200,
            minHeight: 500,
            close: (e) => {
                this.callback(this.vessels.getSelected())
                this.popup = null;
            }
        });
    }

    protected getTitle(): string {
        return i18n.getMessage("VisuRIS.Directions.MyVessels");
    }

    protected async getContent(): Promise<JQuery<HTMLElement>> {
        const html = await import('text!visuris/ui/Vessels/VesselPopup.html');
        let $html = $(html);

        this.vessels.selected.on((e) => {
            $html.find('.button-ok').removeAttr("disabled")
        });

        $html.find('.button-ok').on("click", (e: JQuery.Event) => {
            messageToParent('close', this.vessels.getSelected())
            this.close(e);
        });

        $html.find('.button-cancel').on('click', (e: JQuery.Event) => {
            messageToParent('close', null );
            this.close(e);
        });

        // double click event -> select and close
        $html.on("dblclick", "div.k-state-selected", (e) => {
            messageToParent('close', this.vessels.getSelected());
            this.close(e);
        });

        i18n.bind($html);
        return await this.vessels.initialize($html[0], { canManage: false, canSelect: true });
    }

    public async close(e: any) {
        this.popup.close(e);
    }
}  